import React, { useState, useEffect } from "react";
import {
  getFirestore,
  doc,
  setDoc,
  collection,
  onSnapshot,
  deleteDoc,
  Timestamp,
  query,
  where,
} from "firebase/firestore";
import { getStorage, ref, uploadBytes, getDownloadURL } from "firebase/storage";
import app from "../firebase";
import "./AdminPanel.css";
import { useCuerpo } from "../context/CuerpoContext";

const db = getFirestore(app);
const storage = getStorage(app);

// Normalizar RUT igual que en VistaGlobal (manteniendo guion)
function normalizarRut(rut) {
  if (!rut) return "";
  let limpio = rut.replace(/\./g, "").replace(/\s+/g, "").toUpperCase();

  if (!limpio.includes("-") && limpio.length > 1) {
    const cuerpo = limpio.slice(0, -1);
    const dv = limpio.slice(-1);
    limpio = `${cuerpo}-${dv}`;
  }

  return limpio;
}

export default function RegistroOperadoras() {
  const { cuerpoId } = useCuerpo();
  const [rut, setRut] = useState("");
  const [nombre, setNombre] = useState("");
  const [foto, setFoto] = useState(null);

  const [operadoras, setOperadoras] = useState([]);

  // Cargar operadoras desde Firebase
  useEffect(() => {
    if (!cuerpoId) return;
    const colRef = query(collection(db, "operadoras"), where("cuerpo_id", "==", cuerpoId));
    const unsub = onSnapshot(colRef, (snap) => {
      const lista = snap.docs.map((d) => ({ id: d.id, ...d.data() }));
      lista.sort((a, b) =>
        (a.nombreCompleto || "").localeCompare(b.nombreCompleto || "")
      );
      setOperadoras(lista);
    });

    return () => unsub();
  }, [cuerpoId]);

  const handleGuardar = async () => {
    const rutNorm = normalizarRut(rut);

    if (!rutNorm || !nombre.trim()) {
      alert("Debes ingresar nombre completo y RUT.");
      return;
    }

    try {
      let fotoURL = null;

      if (foto) {
        const archivoRef = ref(storage, `operadoras/${cuerpoId}/${rutNorm}.jpg`);
        await uploadBytes(archivoRef, foto);
        fotoURL = await getDownloadURL(archivoRef);
      }

      await setDoc(
        doc(db, "operadoras", rutNorm),
        {
          rut: rutNorm,
          nombreCompleto: nombre.trim(),
          fotoURL: fotoURL || null,
          creadoEn: Timestamp.now(),
          cuerpo_id: cuerpoId,
        },
        { merge: true }
      );

      alert("Operadora registrada correctamente.");
      setRut("");
      setNombre("");
      setFoto(null);
    } catch (err) {
      alert("Error al registrar operadora: " + err.message);
    }
  };

  const borrarOperadora = async (id) => {
    if (!window.confirm("¿Eliminar esta operadora?")) return;

    try {
      await deleteDoc(doc(db, "operadoras", id));
    } catch (err) {
      alert("Error al eliminar: " + err.message);
    }
  };

  return (
    <div style={{ maxWidth: 600 }}>
      <h2>Registro de Operadoras</h2>

      <div className="formulario">
        <div>
          <label>Nombre completo *</label>
          <input
            type="text"
            value={nombre}
            onChange={(e) => setNombre(e.target.value)}
            placeholder="Ej: Ana Pérez Soto"
          />
        </div>

        <div>
          <label>RUT *</label>
          <input
            type="text"
            value={rut}
            onChange={(e) => setRut(e.target.value)}
            placeholder="12.345.678-9"
          />
        </div>

        <div>
          <label>Fotografía (opcional)</label>
          <input
            type="file"
            accept="image/*"
            onChange={(e) => setFoto(e.target.files[0])}
          />
        </div>

        <button onClick={handleGuardar}>Guardar operadora</button>
      </div>

      <h3 style={{ marginTop: 30 }}>Operadoras Registradas</h3>

      <table className="tabla">
        <thead>
          <tr>
            <th>Foto</th>
            <th>Nombre</th>
            <th>RUT</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          {operadoras.map((o) => (
            <tr key={o.id}>
              <td>
                {o.fotoURL ? (
                  <img
                    src={o.fotoURL}
                    alt={o.nombreCompleto}
                    style={{
                      width: 45,
                      height: 55,
                      objectFit: "cover",
                      borderRadius: 6,
                    }}
                  />
                ) : (
                  <div
                    style={{
                      width: 45,
                      height: 55,
                      background: "#ddd",
                      borderRadius: 6,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      fontSize: "0.6rem",
                    }}
                  >
                    SIN FOTO
                  </div>
                )}
              </td>
              <td>{o.nombreCompleto}</td>
              <td>{o.rut}</td>
              <td>
                <button onClick={() => borrarOperadora(o.id)}>Eliminar</button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
